/** EN uses Swedish values until translated. */
export const notesTranslationsEn = {
    title: 'Notes',
    description: 'Your notes on issues, warrants and convertibles.',
    expandAll: 'Expand all notes',
    columns: {
        name: 'Name',
        updated: 'Updated',
        note: 'Note',
    },
    errors: {
        couldNotRead: 'Could not read the note.',
        couldNotLoad: 'Could not load the notes.',
        couldNotDelete: 'Could not delete the note.',
        couldNotSave: 'Could not save the note.',
    },
    deleteConfirm: {
        message: 'Are you sure you want to delete the note?',
        title: 'Delete note',
        confirmLabel: 'Delete',
    },
    editor: {
        title: 'Note',
        placeholder: 'Write a note...',
        tooltip: 'Note',
        ariaLabel: 'Note',
    },
}
